<template>
    <div :class="wrapSize">
        <div v-if="label" :class="labelWrap">
            <label :for="labelFor" class="inline-block text-80 leading-tight font-semibold">{{ label }}</label>
        </div>
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'InputControl',

    props: {
      wrapSize: {
        type: String,
        default: 'mb-6',
      },
      labelWrap: {
        type: String,
        default: 'mb-2',
      },
      label: {
        type: String,
        default: '',
      },
      labelFor: {
        type: String,
        default: '',
      },
    },
  };
</script>
